import HeaderLogo from '~/components/layout/Header/HeaderLogo.tsx';
import Container from '~/components/ui/Container.tsx';
import { cn } from '~/helpers/utils.ts';
import { useHeadroom } from '~/hooks/useHeadroom.ts';

const BasicHeader = () => {
  const headroom = useHeadroom();

  return (
    <header
      role="banner"
      className={cn(
        'sticky top-0 z-[999999] bg-white transition-transform duration-300',
        headroom === 'unpinned' ? '-translate-y-full' : 'translate-y-0'
      )}
    >
      <Container>
        <HeaderLogo />
      </Container>
    </header>
  );
};

export default BasicHeader;
